<template>
  <div>
    <page-header title="Перевозка промышленного оборудования"/>
    <div id="about" class="public-container public-container-mobile shipping-types">
      <div class="shipping-types-banner-wrapper">
        <div class="shipping-types-banner mb-30">
          <public-card-info img-url="/images/pages/shipping-type/industrial-equipment.png">
            <div class="shipping-types-card-text">
              {{ content.blocks?.about.cardText }}
            </div>
          </public-card-info>
        </div>

        <div>
          <p>
            {{ content.blocks?.about.description }}
          </p>
        </div>
      </div>

      <div class="shipping-types-block">
        <h2 class="vz-text-align-left">{{ content.blocks?.about.title }}</h2>
        <div class="whitespace-break-spaces" v-html="content.blocks?.about.text" />
      </div>

      <shipping-types-buttons />

      <div id="price" class="shipping-types-block mb-90">
        <h2 class="vz-text-align-left">{{ content.blocks?.price.title }}</h2>
        <p>
          {{ content.blocks?.price.description }}
        </p>
      </div>

      <shipping-types-chain current="industrial-equipment" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import {getPageContent} from '~/api/content'

const content = await getPageContent('/shippingtypes/industrial-equipment')
</script>
